import React from "react";
import "./MoreSection.scss";

type Props = {};

const MoreSection: React.FC<Props> = () => {
  return <div className="MoreSection"></div>;
};

export default React.memo(MoreSection);
